



































































import { Component, Vue, Prop } from "vue-property-decorator";

import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { CustomerAuthConfigModel } from "../../Generated/ParticaAPI";

@Component(
	{
		name: "Auth0Config",
		components: { ButtonList }
	})
export default class Auth0Config extends ParticaBaseForm<CustomerAuthConfigModel> {

	private authDomainconfig =
		{
			props: {
				name: "Domain",
				placeholder: "Enter Domain",
				label: "Auth0 domain",
			} as FormFieldProps,
			rules: { required: true, url: true } as FormFieldRules
		} as IFormField;

	private secretconfig =
		{
			props: {
				name: "Client secret",
				placeholder: "Enter secret",
				label: "Auth0 client secret",
			} as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;

	private clientIdconfig =
		{
			props: {
				name: "Client Id",
				placeholder: "Enter clientId",
				label: "Auth0 ClientId",
			} as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;

	private widgetOptionsconfig =
		{
			props: {
				name: "Widget Options",
				placeholder: "Enter Widget Options",
				label: "Lock widget options",
			} as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;

	private apiClientIdconfig =
		{
			props: {
				name: "API ClientId",
				placeholder: "Enter API ClientId",
				label: "Auth0 API ClientId",
			} as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;

	private apiClientSecretconfig =
		{
			props: {
				name: "API ClientSecret",
				placeholder: "Enter API ClientSecret",
				label: "Auth0 API Secret",
			} as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;

	private authProviderconfig =
		{
			props: {
				name: "authProvider",
				placeholder: "Enter authProvider",
				label: "Auth Provider", disabled: true
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private scopeconfig =
		{
			props: {
				name: "Scope",
				placeholder: "Enter Scope",
				label: "Scope",
			} as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;

}
